import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import dummyData from '../data.json'; // Import JSON
import { useSelector } from 'react-redux';

export default function QueueChart() {
  const [queueData, setQueueData] = useState([]);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const threshold = 6;
  const currentDate = useSelector((state) => state.customization.currentDate);

  const formatDate = (date) => {
    if (!date) return '';

      if (typeof date === 'string') {
    return date;
  }
  
  // Check if it's a valid Date object
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return '';
  }
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are 0-indexed
    const year = date.getFullYear().toString().slice(-2); // Get last 2 digits (25)
    return `${day}-${month}-${year}`;
  };

  const formattedDate = formatDate(currentDate);

  useEffect(() => {
    if (formattedDate === '29-4-25') {
      const data = dummyData.queueCount || [];
      setQueueData(data);
      setIsDataAvailable(data.length > 0);
    } else {
      setQueueData([]);
      setIsDataAvailable(false);
    }
  }, [formattedDate]);

  if (!currentDate) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '8px'
      }}>
        <p style={{ color: '#6c757d', fontSize: '16px' }}>Please select a date to view queue data</p>
      </div>
    );
  }

  if (!isDataAvailable) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '8px'
      }}>
        <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '8px' }}>
        No Integrations Found
        </p>
       
      </div>
    );
  }

  const times = queueData.map((item) => item?.time || 'N/A');
  const counter1Data = queueData.map((item) => item?.counter1 || 0);
  const counter2Data = queueData.map((item) => item?.counter2 || 0);
  const counter3Data = queueData.map((item) => item?.counter3 || 0);

  const chartOptions = {
    chart: {
      type: 'area',
      height: 400,
      toolbar: { show: false }
    },
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    markers: {
      size: 4,
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: { size: 6 }
    },
    xaxis: {
      categories: times,
      title: { text: 'Time', style: { fontSize: '14px' } }
    },
    yaxis: {
      title: { text: 'Queue Count', style: { fontSize: '14px' } },
      min: 0,
      max: 16
    },
    annotations: {
      yaxis: [
        {
          y: threshold,
          borderColor: '#FF0000',
          strokeDashArray: 5,
          label: {
            borderColor: '#FF0000',
            style: {
              color: 'white',
              background: '#FF0000',
              fontSize: '12px'
            },
            text: `Threshold: ${threshold}`
          }
        }
      ]
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '14px'
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.3,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 100]
      }
    },
    colors: ['#A8E4B1', '#44BE54', '#247331'],
    noData: {
      text: 'No data available',
      align: 'center',
      verticalAlign: 'middle',
      style: {
        color: '#6c757d',
        fontSize: '16px'
      }
    }
  };

  const chartSeries = [
    { name: 'Counter 1', data: counter1Data },
    { name: 'Counter 2', data: counter2Data },
    { name: 'Counter 3', data: counter3Data }
  ];

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <Chart 
        options={chartOptions} 
        series={chartSeries} 
        type="area" 
        height={480} 
        width="100%" 
      />
    </div>
  );
}